export default {
  'login.title': 'تسجيل دخول المدير',
  'login.subtitle': 'يرجى تسجيل الدخول بحساب المدير المعين من قبل المدير الأعلى',
  'login.email': 'اسم المستخدم / البريد الإلكتروني',
  'login.emailPlaceholder': 'أدخل اسم المستخدم أو البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.passwordPlaceholder': 'أدخل كلمة المرور',
  'login.submit': 'تسجيل الدخول',
  'login.loading': 'جاري تسجيل الدخول...',
  'login.failed': 'فشل تسجيل الدخول',
  'login.networkError': 'خطأ في الشبكة',
  'login.unknownError': 'خطأ غير معروف',
  'login.emptyFields': 'يرجى إدخال اسم المستخدم وكلمة المرور',
  'login.showPassword': 'إظهار كلمة المرور',
  'login.hidePassword': 'إخفاء كلمة المرور',
  'login.noSelfRegister': 'لا يوفر هذا النظام التسجيل الذاتي. يرجى الاتصال بالمدير الأعلى لإنشاء حساب.',
  'login.footerText': 'منصة إدارة متعددة المستأجرين',
  'login.brandTitle1': 'وحدة التحكم',
  'login.brandTitle2': 'متعددة المستأجرين',
  'login.brandSlogan': 'إدارة موحدة للمستأجرين والمستخدمين والموارد وسياسات الفوترة لعمليات أكثر كفاءة وأمانا.',
  'login.feature1Title': 'التحكم في الوصول',
  'login.feature1Desc': 'التحكم في الوصول على مستوى المؤسسة وسجلات التدقيق',
  'login.feature2Title': 'عزل البيانات',
  'login.feature2Desc': 'عزل بيانات متعدد المستأجرين وإدارة الحصص',
  'login.feature3Title': 'المراقبة',
  'login.feature3Desc': 'لوحات مراقبة في الوقت الفعلي وتحليل التقارير',
  'sidebar.home': 'لوحة التحكم',
  'sidebar.users': 'المستخدمون والصلاحيات',
  'sidebar.resources': 'الميزات والموارد',
  'sidebar.tenants': 'إدارة المستأجرين',
  'sidebar.audit': 'سجل المراجعة',
  'sidebar.reports': 'التقارير',
  'sidebar.settings': 'الإعدادات',
  'sidebar.admin': 'مدير النظام',
  'header.search': 'بحث المستأجرين، المستخدمين، الموارد...',
  'header.notifications': 'الإشعارات',
  'header.viewAll': 'عرض جميع الإشعارات',
  'header.profile': 'الملف الشخصي',
  'header.settings': 'الإعدادات',
  'header.logout': 'تسجيل الخروج',
  'header.notif.newTenant': 'تسجيل مستأجر جديد',
  'header.notif.newTenantMsg': 'تم تسجيل شركة تك إنوفيشن',
  'header.notif.apiWarning': 'تحذير استخدام API',
  'header.notif.apiWarningMsg': 'المستأجر T002 يقترب من حد الحصة',
  'header.notif.systemUpdate': 'تحديث النظام',
  'header.notif.systemUpdateMsg': 'صيانة النظام الليلة',
  'header.notif.5minAgo': 'منذ 5 دقائق',
  'header.notif.1hourAgo': 'منذ ساعة',
  'header.notif.3hoursAgo': 'منذ 3 ساعات',
  'home.title': 'نظرة عامة',
  'home.subtitle': 'مرحبًا بعودتك، هذه منصة إدارة متعددة المستأجرين',
  'home.totalTenants': 'إجمالي المستأجرين',
  'home.totalUsers': 'إجمالي المستخدمين',
  'home.apiCalls': 'استدعاءات API',
  'home.totalRevenue': 'إجمالي الإيرادات',
  'home.totalSkills': 'إجمالي المهارات',
  'home.chatSessions': 'جلسات المحادثة',
  'home.totalMessages': 'إجمالي الرسائل',
  'home.systemHealth': 'صحة النظام',
  'home.active': 'نشط',
  'home.activeShort': 'نشط',
  'home.thisMonth': 'هذا الشهر',
  'home.published': 'منشور',
  'home.cumulative': 'تراكمي',
  'home.running': 'يعمل بشكل طبيعي',
  'home.vsLastMonth': 'مقارنة بالشهر السابق',
  'home.apiTrend': 'اتجاه استخدام API',
  'home.revenueTrend': 'اتجاه الإيرادات',
  'home.quickAccess': 'وصول سريع',
  'home.recentActivity': 'النشاط الأخير',
  'home.viewAll': 'عرض الكل',
  'home.tenantDistribution': 'توزيع المستأجرين',
  'home.success': 'نجاح',
  'home.failed': 'فشل',
  'tenants.title': 'إدارة المستأجرين',
  'tenants.subtitle': 'إدارة الإعدادات والحصص وسياسات الفوترة',
  'tenants.export': 'تصدير القائمة',
  'tenants.create': 'مستأجر جديد',
  'tenants.total': 'الإجمالي',
  'tenants.unit': 'مستأجرين',
  'tenants.clickTip': 'انقر على صف لعرض التفاصيل',
  'tenants.showing': 'عرض',
  'tenants.to': '-',
  'tenants.of': 'من',
  'tenants.records': 'سجلات',
  'tenants.createTitle': 'مستأجر جديد',
  'tenants.createSuccess': 'تم إنشاء المستأجر بنجاح!',
  'tenants.createFailed': 'فشل الإنشاء',
  'tenants.tenantName': 'اسم المستأجر',
  'tenants.subdomain': 'النطاق الفرعي',
  'tenants.contactName': 'اسم جهة الاتصال',
  'tenants.contactEmail': 'بريد جهة الاتصال',
  'tenants.planType': 'نوع الخطة',
  'tenants.deployRegion': 'منطقة النشر',
  'tenants.cancel': 'إلغاء',
  'tenants.createBtn': 'إنشاء مستأجر',
  'tenants.namePlaceholder': 'مثال: شركة تك إنوفيشن',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': 'أحمد',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'أساسي',
  'tenants.plan.professional': 'احترافي',
  'tenants.plan.enterprise': 'مؤسسي',
  'tenants.region.east': 'شرق الصين',
  'tenants.region.north': 'شمال الصين',
  'tenants.region.south': 'جنوب الصين',
  'tenants.region.west': 'غرب الصين',
  'tenantStats.total': 'إجمالي المستأجرين',
  'tenantStats.active': 'المستأجرون النشطون',
  'tenantStats.totalUsers': 'إجمالي المستخدمين',
  'tenantStats.monthlyRevenue': 'الإيرادات الشهرية',
  'tenantFilters.search': 'بحث الاسم أو النطاق أو جهة الاتصال...',
  'tenantFilters.allPlans': 'جميع الخطط',
  'tenantFilters.allStatus': 'جميع الحالات',
  'tenantFilters.active': 'نشط',
  'tenantFilters.suspended': 'معلق',
  'tenantFilters.trial': 'تجريبي',
  'tenantTable.info': 'معلومات المستأجر',
  'tenantTable.plan': 'الخطة',
  'tenantTable.status': 'الحالة',
  'tenantTable.users': 'المستخدمون',
  'tenantTable.apiCalls': 'استدعاءات API',
  'tenantTable.storage': 'التخزين',
  'tenantTable.region': 'المنطقة',
  'tenantTable.lastActive': 'آخر نشاط',
  'tenantTable.actions': 'الإجراءات',
  'tenantTable.viewDetail': 'عرض التفاصيل',
  'tenantTable.edit': 'تعديل',
  'tenantTable.more': 'المزيد',
  'tenantTable.noMatch': 'لا يوجد مستأجرون مطابقون',
  'tenantDetail.overview': 'نظرة عامة',
  'tenantDetail.quotaMgmt': 'إدارة الحصص',
  'tenantDetail.dataIsolation': 'عزل البيانات',
  'tenantDetail.billing': 'الفوترة',
  'tenantDetail.createdAt': 'تاريخ الإنشاء',
  'tenantDetail.resourceUsage': 'استخدام الموارد',
  'tenantDetail.apiCallUsage': 'استدعاءات API',
  'tenantDetail.storageUsage': 'التخزين',
  'tenantDetail.userCount': 'عدد المستخدمين',
  'tenantDetail.contactInfo': 'معلومات الاتصال',
  'tenantDetail.contact': 'جهة الاتصال',
  'tenantDetail.email': 'البريد',
  'tenantDetail.deployRegion': 'منطقة النشر',
  'tenantDetail.lastActive': 'آخر نشاط',
  'tenantDetail.enabledFeatures': 'الميزات المفعلة',
  'tenantDetail.tags': 'علامات المستأجر',
  'tenantDetail.quickActions': 'إجراءات سريعة',
  'tenantDetail.suspend': 'تعليق المستأجر',
  'tenantDetail.resume': 'استئناف المستأجر',
  'tenantDetail.sendNotice': 'إرسال إشعار',
  'tenantDetail.simulateLogin': 'محاكاة تسجيل الدخول',
  'tenantDetail.exportData': 'تصدير البيانات',
  'tenantDetail.quotaSaved': 'تم حفظ الحصة',
  'tenantDetail.quotaSettings': 'إعدادات الحصة',
  'tenantDetail.quotaDesc': 'تعديل حدود الموارد لهذا المستأجر',
  'tenantDetail.maxUsers': 'الحد الأقصى للمستخدمين',
  'tenantDetail.apiCallsMonth': 'استدعاءات API / شهر',
  'tenantDetail.storageSpace': 'التخزين',
  'tenantDetail.currentUsage': 'الاستخدام الحالي',
  'tenantDetail.saveQuota': 'حفظ إعدادات الحصة',
  'tenantDetail.isolationSaved': 'تم حفظ سياسة العزل',
  'tenantDetail.isolationPolicy': 'سياسة عزل البيانات',
  'tenantDetail.isolationDesc': 'اختر طريقة تخزين وعزل البيانات',
  'tenantDetail.dedicated': 'عزل مخصص',
  'tenantDetail.dedicatedDesc': 'قاعدة بيانات مخصصة، عزل كامل، أمان أقصى',
  'tenantDetail.shared': 'عزل مشترك',
  'tenantDetail.sharedDesc': 'قاعدة بيانات مشتركة مع أمان على مستوى الصفوف',
  'tenantDetail.recommended': 'موصى به',
  'tenantDetail.permissionConfig': 'إعدادات الصلاحيات',
  'tenantDetail.crossTenantAccess': 'الوصول عبر المستأجرين',
  'tenantDetail.crossTenantDesc': 'السماح بالوصول للبيانات العامة للمستأجرين الآخرين',
  'tenantDetail.apiRateLimit': 'تحديد معدل API',
  'tenantDetail.apiRateLimitDesc': 'تطبيق حدود المعدل على طلبات API',
  'tenantDetail.dataExport': 'صلاحية تصدير البيانات',
  'tenantDetail.dataExportDesc': 'السماح لهذا المستأجر بتصدير بياناته',
  'tenantDetail.auditAccess': 'الوصول لسجل المراجعة',
  'tenantDetail.auditAccessDesc': 'السماح بعرض سجلات المراجعة الخاصة',
  'tenantDetail.saveIsolation': 'حفظ سياسة العزل',
  'tenantDetail.currentPlan': 'تكلفة الخطة الحالية',
  'tenantDetail.perMonth': '/ شهر',
  'tenantDetail.nextBilling': 'تاريخ الفاتورة التالية',
  'tenantDetail.billDetail': 'تفاصيل الفاتورة',
  'tenantDetail.baseFee': 'رسوم الخطة الأساسية',
  'tenantDetail.apiCallFee': 'رسوم استدعاء API',
  'tenantDetail.storageFee': 'رسوم التخزين',
  'tenantDetail.supportFee': 'رسوم الدعم الفني',
  'tenantDetail.total': 'الإجمالي',
  'tenantDetail.historyBills': 'سجل الفواتير',
  'tenantDetail.paid': 'مدفوع',
  'tenantDetail.download': 'تحميل',
  'tenantDetail.feature.aiModels': 'نماذج الذكاء الاصطناعي',
  'tenantDetail.feature.apiAccess': 'الوصول لـ API',
  'tenantDetail.feature.advancedAnalytics': 'تحليلات متقدمة',
  'tenantDetail.feature.basicAnalytics': 'تحليلات أساسية',
  'tenantDetail.feature.customDomain': 'نطاق مخصص',
  'tenantDetail.feature.sso': 'SSO',
  'tenantDetail.feature.whiteLabel': 'العلامة البيضاء',
  'users.title': 'إدارة المستخدمين والصلاحيات',
  'users.subtitle': 'إدارة حسابات المستخدمين وصلاحيات جميع المستأجرين',
  'users.addUser': 'إضافة مستخدم',
  'users.totalUsers': 'إجمالي المستخدمين',
  'users.activeUsers': 'المستخدمون النشطون',
  'users.admins': 'المسؤولون',
  'users.developers': 'المطورون',
  'users.loading': 'جاري التحميل...',
  'userFilters.search': 'بحث الاسم أو البريد أو المستأجر...',
  'userFilters.allRoles': 'جميع الأدوار',
  'userFilters.admin': 'مسؤول',
  'userFilters.user': 'مستخدم عادي',
  'userFilters.developer': 'مطور',
  'userFilters.allStatus': 'جميع الحالات',
  'userFilters.active': 'نشط',
  'userFilters.inactive': 'غير نشط',
  'userFilters.moreFilters': 'مزيد من الفلاتر',
  'userTable.user': 'المستخدم',
  'userTable.tenant': 'المستأجر',
  'userTable.role': 'الدور',
  'userTable.status': 'الحالة',
  'userTable.lastLogin': 'آخر تسجيل دخول',
  'userTable.actions': 'الإجراءات',
  'userTable.role.admin': 'مسؤول',
  'userTable.role.user': 'مستخدم',
  'userTable.role.developer': 'مطور',
  'userTable.status.active': 'نشط',
  'userTable.status.inactive': 'غير نشط',
  'resources.title': 'إعدادات الخدمات',
  'resources.subtitle': 'إدارة نماذج الذكاء الاصطناعي ومفاتيح API والتكامل',
  'resources.refresh': 'تحديث',
  'resources.addConfig': 'إضافة إعداد',
  'resources.totalConfigs': 'إجمالي الإعدادات',
  'resources.active': 'نشط',
  'resources.categories': 'الفئات',
  'resources.secrets': 'الأسرار',
  'resources.addTitle': 'إضافة إعداد جديد',
  'resources.category': 'الفئة',
  'resources.configKey': 'مفتاح الإعداد',
  'resources.displayName': 'اسم العرض',
  'resources.value': 'القيمة',
  'resources.description': 'الوصف',
  'resources.secretValue': 'قيمة سرية',
  'resources.type': 'النوع:',
  'resources.save': 'حفظ',
  'resources.cancel': 'إلغاء',
  'resources.create': 'إنشاء',
  'resources.configs': 'إعدادات',
  'resources.items': 'عناصر',
  'resources.notConfigured': 'غير مُعد',
  'resources.noConfigs': 'لم يتم العثور على إعدادات',
  'resources.running': 'قيد التشغيل',
  'resources.maintenance': 'صيانة',
  'resources.endpoint': 'نقطة النهاية',
  'resources.usageTenants': 'المستأجرون المستخدمون',
  'resources.usageUnit': '',
  'resources.usage': 'الاستخدام',
  'resources.configure': 'تهيئة',
  'resources.stats': 'إحصائيات',
  'resources.modelType': 'النوع',
  'resources.version': 'الإصدار',
  'resources.callCount': 'عدد الاستدعاءات',
  'resources.cost': 'التكلفة',
  'resources.apiKey': 'مفتاح API',
  'resources.edit': 'تعديل',
  'resources.usageStats': 'إحصائيات الاستخدام',
  'settings.title': 'إعدادات النظام',
  'settings.subtitle': 'إدارة الإعدادات العامة وسياسات الأمان والترجمة',
  'settings.tab.general': 'عام',
  'settings.tab.services': 'الخدمات',
  'settings.tab.security': 'الأمان',
  'settings.tab.notification': 'الإشعارات',
  'settings.tab.billing': 'خطط الفوترة',
  'settings.tab.locale': 'اللغات',
  'settings.systemInfo': 'معلومات النظام',
  'settings.version': 'الإصدار',
  'settings.environment': 'البيئة',
  'settings.production': 'إنتاج',
  'settings.availability': 'التوفر',
  'settings.lastBackup': 'آخر نسخ احتياطي',
  'settings.todayAt': 'اليوم 03:00',
  'general.platformInfo': 'معلومات المنصة',
  'general.platformName': 'اسم المنصة',
  'general.platformUrl': 'عنوان المنصة',
  'general.supportEmail': 'بريد الدعم',
  'general.timezone': 'المنطقة الزمنية',
  'general.dateFormat': 'تنسيق التاريخ',
  'general.maxTenants': 'الحد الأقصى للمستأجرين / خطة',
  'general.sessionMaintenance': 'الجلسة والصيانة',
  'general.sessionTimeout': 'مهلة الجلسة',
  'general.sessionTimeoutDesc': 'تسجيل خروج تلقائي عند عدم النشاط',
  'general.minutes': 'دقائق',
  'general.maintenanceMode': 'وضع الصيانة',
  'general.maintenanceDesc': 'سيرى المستخدمون صفحة صيانة عند التفعيل',
  'general.maintenanceWarning': 'وضع الصيانة مفعل. جميع المستخدمين لا يمكنهم الوصول للمنصة.',
  'general.reset': 'إعادة تعيين',
  'general.save': 'حفظ الإعدادات',
  'general.saved': 'تم الحفظ',
  'security.authPolicy': 'سياسة المصادقة',
  'security.mfa': 'فرض المصادقة متعددة العوامل',
  'security.mfaDesc': 'يجب على جميع حسابات المسؤولين تفعيل MFA',
  'security.sso': 'تسجيل دخول موحد SSO',
  'security.ssoProtocol': 'البروتوكول الحالي',
  'security.passwordPolicy': 'سياسة كلمة المرور',
  'security.minLength': 'الحد الأدنى للطول',
  'security.chars': 'أحرف',
  'security.expireDays': 'انتهاء صلاحية كلمة المرور',
  'security.days': 'أيام',
  'security.maxAttempts': 'أقصى محاولات تسجيل دخول',
  'security.times': 'مرات',
  'security.lockoutDuration': 'مدة قفل الحساب',
  'security.ipWhitelist': 'القائمة البيضاء لـ IP',
  'security.ipPlaceholder': 'أدخل IP أو CIDR مثل 192.168.1.0/24',
  'security.add': 'إضافة',
  'security.ipWhitelistDesc': 'عند التفعيل، فقط عناوين IP في القائمة البيضاء يمكنها الوصول.',
  'security.auditLog': 'سجل المراجعة',
  'security.retentionDays': 'أيام الاحتفاظ',
  'security.retentionDesc': 'سيتم حذف السجلات الأقدم تلقائيًا',
  'security.reset': 'إعادة تعيين',
  'security.save': 'حفظ الإعدادات',
  'security.saved': 'تم الحفظ',
  'notification.channels': 'قنوات الإشعارات',
  'notification.email': 'إشعارات البريد',
  'notification.emailDesc': 'إرسال التنبيهات والتقارير عبر البريد',
  'notification.sms': 'إشعارات SMS',
  'notification.smsDesc': 'إرسال التنبيهات العاجلة عبر SMS',
  'notification.webhook': 'Webhook',
  'notification.webhookDesc': 'إرسال الأحداث إلى عنوان URL محدد',
  'notification.webhookUrl': 'عنوان Webhook',
  'notification.alertEvents': 'أحداث التنبيه',
  'notification.tenantCreate': 'تسجيل مستأجر جديد',
  'notification.tenantCreateDesc': 'إشعار عند تسجيل مستأجر جديد',
  'notification.quotaExceed': 'تنبيه تجاوز الحصة',
  'notification.quotaExceedDesc': 'إشعار عند تجاوز استخدام API نسبة 90%',
  'notification.loginFail': 'تنبيه فشل تسجيل الدخول',
  'notification.loginFailDesc': 'إشعار عند بلوغ محاولات تسجيل الدخول الفاشلة الحد',
  'notification.systemError': 'تنبيه خطأ النظام',
  'notification.systemErrorDesc': 'إشعار فوري عند حدوث خطأ حرج',
  'notification.scheduledReport': 'التقارير المجدولة',
  'notification.dailyReport': 'التقرير اليومي',
  'notification.dailyReportDesc': 'إرسال ملخص البيانات التشغيلية يوميًا',
  'notification.sendTime': 'وقت الإرسال',
  'notification.recipients': 'مستلمو التقارير',
  'notification.emailPlaceholder': 'أدخل البريد الإلكتروني',
  'notification.addBtn': 'إضافة',
  'notification.reset': 'إعادة تعيين',
  'notification.save': 'حفظ الإعدادات',
  'notification.saved': 'تم الحفظ',
  'billing.saved': 'تم حفظ الخطة',
  'billing.totalPlans': 'إجمالي الخطط',
  'billing.activePlans': 'الخطط النشطة',
  'billing.highestPrice': 'أعلى سعر',
  'billing.editing': 'قيد التعديل',
  'billing.cancel': 'إلغاء',
  'billing.save': 'حفظ',
  'billing.planName': 'اسم الخطة',
  'billing.monthlyFee': 'الرسوم الشهرية (CNY)',
  'billing.apiCallsMonth': 'استدعاءات API / شهر',
  'billing.storageSpace': 'التخزين (GB)',
  'billing.maxUsers': 'الحد الأقصى للمستخدمين',
  'billing.supportType': 'نوع الدعم',
  'billing.disabled': 'معطل',
  'billing.perMonth': '/ شهر',
  'billing.edit': 'تعديل',
  'billing.apiLabel': 'استدعاءات API',
  'billing.storageLabel': 'التخزين',
  'billing.usersLabel': 'المستخدمون',
  'billing.supportLabel': 'الدعم',
  'locale.defaultLang': 'إعدادات اللغة الافتراضية',
  'locale.platformDefault': 'اللغة الافتراضية للمنصة',
  'locale.platformDefaultDesc': 'اللغة المستخدمة عند الزيارة الأولى',
  'locale.fallbackLang': 'اللغة الاحتياطية',
  'locale.fallbackLangDesc': 'تُستخدم عند عدم توفر الترجمة',
  'locale.autoDetect': 'اكتشاف لغة المتصفح تلقائيًا',
  'locale.autoDetectDesc': 'تبديل اللغة تلقائيًا حسب إعدادات المتصفح',
  'locale.tenantOverride': 'السماح بتخصيص لغة المستأجر',
  'locale.tenantOverrideDesc': 'يمكن للمستأجرين تجاوز اللغة الافتراضية',
  'locale.langManagement': 'إدارة حزم اللغة',
  'locale.enabled': 'مفعل',
  'locale.default': 'افتراضي',
  'locale.translationCoverage': 'تغطية الترجمة',
  'locale.cannotDisable': 'لا يمكن تعطيل اللغة الافتراضية',
  'locale.coverageNote': 'ملاحظة حول التغطية',
  'locale.coverageDesc': 'حزم اللغة بتغطية أقل من 80% قد تعرض بعض العناصر باللغة الاحتياطية.',
  'locale.save': 'حفظ الإعدادات',
  'locale.saved': 'تم الحفظ',
  'serviceConfigs.title': 'إعدادات الخدمات',
  'serviceConfigs.subtitle': 'إدارة نماذج AI ومفاتيح API والتكامل الخارجي',
  'serviceConfigs.refresh': 'تحديث',
  'audit.title': 'سجل المراجعة',
  'audit.subtitle': 'سجلات العمليات والمراجعة الأمنية',
  'audit.totalLogs': 'إجمالي السجلات',
  'audit.totalLogsDesc': 'جميع سجلات العمليات',
  'audit.successOps': 'العمليات الناجحة',
  'audit.successRate': 'معدل النجاح',
  'audit.failedOps': 'العمليات الفاشلة',
  'audit.failedDesc': 'تحتاج انتباه',
  'audit.todayOps': 'عمليات اليوم',
  'audit.todayDesc': 'نشاط اليوم',
  'audit.tenant': 'المستأجر',
  'audit.allTenants': 'جميع المستأجرين',
  'audit.actionType': 'نوع العملية',
  'audit.allActions': 'جميع العمليات',
  'audit.status': 'الحالة',
  'audit.allStatus': 'جميع الحالات',
  'audit.success': 'نجاح',
  'audit.failed': 'فشل',
  'audit.timeRange': 'الفترة الزمنية',
  'audit.allTime': 'كل الأوقات',
  'audit.today': 'اليوم',
  'audit.last7days': 'آخر 7 أيام',
  'audit.last30days': 'آخر 30 يومًا',
  'audit.keyword': 'بحث بالكلمة المفتاحية',
  'audit.keywordPlaceholder': 'بحث المستخدم، العملية، المورد...',
  'audit.found': 'تم العثور على',
  'audit.records': 'سجلات',
  'audit.clearFilter': 'مسح الفلاتر',
  'audit.time': 'الوقت',
  'audit.user': 'المستخدم',
  'audit.action': 'العملية',
  'audit.resource': 'المورد',
  'audit.ipAddress': 'عنوان IP',
  'audit.actions': 'الإجراءات',
  'audit.viewDetail': 'عرض التفاصيل',
  'audit.showing': 'عرض',
  'audit.prevPage': 'السابق',
  'audit.nextPage': 'التالي',
  'audit.detailTitle': 'تفاصيل العملية',
  'audit.logId': 'معرف السجل',
  'audit.operationTime': 'وقت العملية',
  'audit.operationStatus': 'حالة العملية',
  'audit.tenantInfo': 'معلومات المستأجر',
  'audit.tenantId': 'معرف المستأجر',
  'audit.tenantName': 'اسم المستأجر',
  'audit.operationUser': 'المستخدم المنفذ',
  'audit.userId': 'معرف المستخدم',
  'audit.userName': 'اسم المستخدم',
  'audit.operationInfo': 'معلومات العملية',
  'audit.operationType': 'نوع العملية',
  'audit.operationResource': 'المورد',
  'audit.operationDetail': 'التفاصيل',
  'audit.networkInfo': 'معلومات الشبكة',
  'audit.userAgent': 'User Agent',
  'reports.title': 'التقارير والتحليلات',
  'reports.subtitle': 'تحليل بيانات متعدد الأبعاد وتقارير مرئية',
  'reports.last7days': 'آخر 7 أيام',
  'reports.last30days': 'آخر 30 يومًا',
  'reports.last90days': 'آخر 90 يومًا',
  'reports.apiTrend': 'اتجاه استدعاءات API',
  'reports.revenueCompare': 'مقارنة إيرادات المستأجرين',
  'reports.resourceUsage': 'استخدام الموارد',
  'reports.userActivity': 'نشاط المستخدمين',
  'reports.activeUsers': 'المستخدمون النشطون',
  'reports.newUsers': 'المستخدمون الجدد',
  'reports.tenantSummary': 'ملخص بيانات المستأجرين',
  'reports.tenantName': 'اسم المستأجر',
  'reports.apiCalls': 'استدعاءات API',
  'reports.storageUsage': 'استخدام التخزين',
  'reports.userCount': 'المستخدمون',
  'reports.revenue': 'الإيرادات',
  'reports.quotaUsage': 'استخدام الحصة',
  'langSwitcher.title': 'اللغة / Language',
};
